(function($) {
  Drupal.behaviors.product_shades_brief_v1 = {
    attach: function(context, settings) {
      var productThumbs = $('.product_brief__image');

      //Check whether the element is in view port
      function isScrolledIntoView(elem) {
        var $elem = $(elem);
        var $window = $(window);

        var docTop = $window.scrollTop();
        var docBottom = docTop + $window.height();

        var elemTop = $elem.offset().top;
        var elemBottom = elemTop + $elem.height();

        return (((elemTop >= docTop) && (elemTop <= docBottom)) || ((elemBottom >= docTop) && (elemBottom <= docBottom)));
      }

      //Load the product images if the img tag is in viewable area
      function lazyLoading() {
        productThumbs.each(function(i, item) {
          if (isScrolledIntoView(item) && !$(item).hasClass('processed')) {
            $(item).addClass('processed');
            var imageUrl = $(item).attr('data-sku-image');
            $(item).attr("src", imageUrl);
            alternativeImage(item);

            $(item).on('load', function() {
              $(this).removeClass("loader");
            }).each(function() {
              if (this.complete) $(this).load();
            }).error(function() {
              if($(this).hasClass( "show-alter-image" )){
                var defaultUrl = $(this).attr('data-default-image');
                $(this).attr('src', defaultUrl);
                $(this).removeClass('show-alter-image').addClass('show-alter-image-renew');
              }

            });

          }
        });
      }

      function alternativeImage(item) {
        if($(item).hasClass( "rollover" ) || $(item).hasClass( "rollover-shades" )){
          var productImage = $(item).attr('data-sku-image');
          var shadeProductName = $(item).hasClass( "show-alter-image" ) ? productImage.substring(41, 55) : productImage.substring(35, 49) ;
          var locale = generic.cookie("LOCALE");
          var localeImage = productImage.substring(35, 58);
          if (locale) {
            if ( locale.indexOf(productImage.substring(58, 61)) >= 2 ) {
              localeImage = productImage.substring(35, 61);
            }
          }
          var rollOver = $(item).hasClass( "rollover-shades" ) ? shadeProductName : localeImage;
          var rollOverPath = $(item).hasClass( "rollover-shades" ) ? '/media/export/cms/mpp/alternative-images/texture/'+ rollOver +'308x424_0_texture.jpg' : '/media/export/cms/mpp/alternative-images/' + rollOver + '_custom.jpg';
          $(item).attr('data-sku-alt-image',rollOverPath);
          var newImage = '<img class="rollover_image hidden" src="'+rollOverPath+'" onError=""></img>';
          $(newImage).insertAfter(item);

          $(item).parent().find("img.rollover_image").load(function() {
            $(item).addClass("rollover-plus-minus");
            $(item).parent().after('<div class="rollover_plus"><img src="/media/export/cms/mpp/plus.png"></div><div class="rollover_minus"><img src="/media/export/cms/mpp/minus.png"></div>'+'<div class="rollover_minus hidden"><img src="/media/export/cms/mpp/minus_black.png">');
          });
        }
      }

      //Load few products images (first 2 rows) on load so that user won't feel any sluggishness
      productThumbs.slice(0, 8).each(function(i, item) {
        $(item).addClass('processed hidden');
        var imageUrl = $(item).attr('data-sku-image');
        alternativeImage(item);

        $(item).attr("src", imageUrl);
        $(item).on('load', function() {
          $(this).removeClass("loader hidden");
        }).each(function() {
          if (this.complete) $(this).load();
        }).error(function() {
          if($(this).hasClass( "show-alter-image" )){
            var defaultUrl = $(this).attr('data-default-image');
            $(this).attr('src', defaultUrl);
            $(this).removeClass('show-alter-image').addClass('show-alter-image-renew');
          }
        });
      });

      //Show products on scrolling
      $(window).on('load', function() {
        $(document).on('scroll', lazyLoading);
        site.product.view.equalMPPRowBottomHeightFunc($('.mpp__product'));
      });

      function debouncer(func, timeout) {
        var timeoutID, timeout = timeout || 200;
        return function() {
          var scope = this,
          args = arguments;
          clearTimeout(timeoutID);
          timeoutID = setTimeout(function() {
            func.apply(scope, Array.prototype.slice.call(args));
          }, timeout);
        }
      }


      $(window).resize(debouncer(function(e) {
        $('.mpp__product').removeAttr('style');
        site.product.view.equalRowHeightFunc($('.mpp__product'));
        site.product.view.equalMPPRowBottomHeightFunc($('.mpp__product'));
      }))

      //Load images on load
      lazyLoading();

      //Load the product images after sorting
      var $sortSelect = $('.js-product-sort');
      $sortSelect.change(function(event) {
        lazyLoading();
      });
    }
  };

})(jQuery);

var site = site || {};
site.product = site.product || {};
site.product.view = site.product.view || {};

//update row bottom heights depends on the buttom content
site.product.view.equalMPPRowBottomHeightFunc = function(gridElement) {
  var $products = $(gridElement);
  var rowCount = site.product.view.findRowCount($products);
  var rows = _.groupBy($products, function(element, index) {
    return Math.floor(index / rowCount); //3 in a row
  });
  rows = _.toArray(rows);
  for (var x in rows) {
    var row = rows[x];
    var maxProductHeight = Math.max.apply(null, $(row).map(function() {
      return $(this).height();
    }).get());

    var buttonDefaultHeight = 0;
    var buttonHeight = $(row).find('.product_brief__buttons-container');
    maxButtonHeight = Math.max.apply(null, buttonHeight.map(function() {
      return $(this).height();
    }).get());

    var defaultBottomHeight = 129;
    if (maxButtonHeight > defaultBottomHeight) {
      buttonHeight.css('bottom', (defaultBottomHeight - maxButtonHeight));
    }
  }
};


site.product.view.extendedMPP = function(args) {

  var that = {};

  that.$productView = $(args.containerNode);
  if (that.$productView.length < 1) return null;

  that.productData = args.productData;
  if (typeof that.productData != "object") return null;

  that.productId = args.productData.PRODUCT_ID;
  that.catId = that.productData.PARENT_CAT_ID;
  that.tagIds = that.catId + '~' + that.productId;
  that.skuId = that.$productView.attr("data-sku-id");

  that.productData.activeSku = _.find(that.productData.skus, function(sku) {
    return sku.SKU_BASE_ID == that.skuId;
  });
  that.productData['skus'] = that.productData.skus;
  that.productData['MISC_FLAG'] = that.productData.MISC_FLAG;
  that.productData['AVERAGE_RATING'] = that.productData.AVERAGE_RATING;
  that.productData['first_sku'] = that.productData['skus'][0];
  that.productData['XL_IMAGE_0'] = that.productData['skus'][0]['XL_IMAGE'][0];

  //image array
  var $imageArray = that.productData['skus'][0]['XL_IMAGE'];
  if (that.productData.shaded == 1) {
    var smooshCheck = that.productData['skus'][0]['XL_IMAGE'][0].indexOf('smoosh');
    if (smooshCheck > 1) {
      $imageArray = $imageArray.slice(1, 2);
    } {
      $imageArray = $imageArray.slice(0, 1);
    }
    $smoosh = that.productData['skus'][0]['XL_SMOOSH'];
    $imageArray.push($smoosh);
  }
  that.productData['IMAGE_ARRAY'] = $imageArray;

  //multiple sizes
  var multipleSizes = _.pluck(that.productData.skus, 'PRODUCT_SIZE');
  multipleSizes = _.uniq(multipleSizes);
  multipleSizes = _.compact(multipleSizes).length > 1 ? true : false;
  if (that.productData.sized && multipleSizes) {
    that.productData['multiple_sizes'] = true;
  } else if ((that.productData.sized && !multipleSizes) || that.productData.shaded) {
    that.productData['multiple_sizes'] = false;
  }

  //skintypes
  var skintypes = _.pluck(that.productData.skus, 'SKIN_TYPE');
  var st = _.filter(that.productData.skus, function(sku) {
    return sku.SKIN_TYPE;
  });
  var skintypes = [];
  var skintypeKey = [];
  var skintypeKeys = [];

  $(st).each(function(index, val) {
    skintypes[index] = [val.SKIN_TYPE, val.SKU_BASE_ID];
  });
  if (skintypes.length > 1) {
    for (var i = 0; i < skintypes.length; i++) {
      if (skintypes[i][0] != 0) {
        skintypeKey.push(skintypes[i][0]);
      }
    }
    skintypeKey = _.uniq(skintypeKey);
    for (var i = 0; i < skintypeKey.length; i++) {
      skintypeKeys.push([skintypeKey[i], '-']);
    }
    for (var x = 0; x < skintypes.length; x++) {
      for (var i = 0; i < skintypeKeys.length; i++) {
        if (skintypes[x][0] == skintypeKeys[i][0]) {
          skintypeKeys[i][1] = skintypeKeys[i][1] + ',' + skintypes[x][1];
        }
      }
    }
    for (var i = 0; i < skintypeKeys.length; i++) {
      skintypeKeys[i][1] = skintypeKeys[i][1].replace("-,", "");
    }
    if (skintypeKeys.length > 1) {
      for (var p = 0; p < skintypeKeys.length; p++) {
        var glue = 'SKINTYPE_' + skintypeKeys[p][0];
        that.productData[glue] = skintypeKeys[p][1];
      }
      that.productData['skintypes'] = 1;
    }
  }

  //misc flag - product level
  var misc_flag = that.productData['MISC_FLAG'];
  if (misc_flag == 1) {
    that.productData['misc_flag_1'] = true;
  } else if (misc_flag == 2) {
    that.productData['misc_flag_2'] = true;
  } else if (misc_flag == 3) {
    that.productData['misc_flag_3'] = true;
  } else if (misc_flag == 94 || misc_flag == 5) {
    that.productData['misc_flag_4'] = true;
  }else if(misc_flag == 15){
    that.productData['misc_flag_5'] = true;
  }

  var skus = that.productData.skus;
  $(skus).each(function(index, sku) {
    var shadeHex = sku.HEX_VALUE_STRING;
    // explode
    var shadeHex = shadeHex.split(',');
    if (shadeHex.length == 1) {
      sku['SWATCH_TYPE'] = 'single';
      sku['HEX_VALUE_1'] = shadeHex[0];
    } else if (shadeHex.length == 2) {
      sku['SWATCH_TYPE'] = 'duo';
      sku['HEX_VALUE_1'] = shadeHex[0];
      sku['HEX_VALUE_2'] = shadeHex[1];
    } else if (shadeHex.length == 3) {
      sku['SWATCH_TYPE'] = 'trio';
      sku['HEX_VALUE_1'] = shadeHex[0];
      sku['HEX_VALUE_2'] = shadeHex[1];
      sku['HEX_VALUE_3'] = shadeHex[2];
    } else if (shadeHex.length == 5) {
      sku['SWATCH_TYPE'] = 'quint';
      sku['HEX_VALUE_1'] = shadeHex[0];
      sku['HEX_VALUE_2'] = shadeHex[1];
      sku['HEX_VALUE_3'] = shadeHex[2];
      sku['HEX_VALUE_4'] = shadeHex[3];
      sku['HEX_VALUE_5'] = shadeHex[4];
    }
    // misc flag
    var sku_misc_flag = sku.MISC_FLAG;
    if (sku_misc_flag == 1) {
      sku['misc_flag_sku_1'] = true;
    } else if (sku_misc_flag == 2) {
      sku['misc_flag_sku_2'] = true;
    } else if (sku_misc_flag == 3) {
      sku['misc_flag_sku_3'] = true;
    } else if (sku_misc_flag == 94 || sku_misc_flag == 5) {
      sku['misc_flag_sku_4'] = true;
    } else if (sku_misc_flag == 15) {
      sku['misc_flag_sku_5'] = true;
    }
  });

  var average = that.productData['AVERAGE_RATING'];
  var scale = 5;
  var calc = average / scale;
  var percentage = Math.round(parseFloat(calc) * 100);
  that.productData['stars_percent'] = percentage;

  var qsTemplate = $('script.inline-template[path="quickshop"]').html();
  var skuName = $('.product_brief__shadename', that.$productView);
  var skuPrice = $('.product_brief__price', that.$productView);

  if (that.productData.sized && !!that.productData.activeSku) {
    if (skuPrice.find('.product_brief__price-loyalty').length > 0) {
      skuPrice.find('.product_brief__price-loyalty').html(that.productData.activeSku.formattedPrice);
    } else {
      skuPrice.html(that.productData.activeSku.formattedPrice);
    }
    skuName.html(that.productData.activeSku.PRODUCT_SIZE).addClass('sized');

    if (skintypeKeys.length > 1) {
      var skuSkinType = $('.quickshop__skintype-select option[value=' + that.productData.activeSku.SKIN_TYPE + ']', qsTemplate);
      skuName.html(that.productData.activeSku.PRODUCT_SIZE + " - " + skuSkinType.text());
      skuName.attr("data-skintype", that.productData.activeSku.SKIN_TYPE);
    }

    //Down Price Updated for Shaded Products
    var productData = that.productData.activeSku;
    if (productData.price2Range) {
      var optionTextHtml = '<span class="product__price--non-sale">'+ skuData.price2Range +'</span><span class="on-sale  product__price--sale">'+ skuData.priceRange;
      skuPrice.html(optionTextHtml);
    } else {
      var skuData= that.productData.activeSku;
      var price2 = (skuData.PRICE2 === undefined) ? '' : skuData.PRICE2;
      var formattedPrice2 = (skuData.formattedPrice2 === undefined) ? '' : skuData.formattedPrice2;
      var formattedPrice = (skuData.formattedPrice === undefined) ? '' : skuData.formattedPrice;
      var productSize = (skuData.PRODUCT_SIZE === undefined) ? '' : skuData.PRODUCT_SIZE;
      if (price2) {
        var optionTextHtml = '<span class="product__price--non-sale">'+ formattedPrice2 +'</span><span class="product__price--sale">'+ formattedPrice +'</span>';
        skuPrice.html(optionTextHtml);
      } else {
        if (skuPrice.find('.product_brief__price-loyalty').length > 0) {
          skuPrice.find('.product_brief__price-loyalty').html(skuData.formattedPrice);
        } else {
          skuPrice.html(skuData.formattedPrice);
        }
      }
    }
  }

  // Quick Shop
  var $btnProductPanel = $('.product_brief__button-panel', that.$productView);
  var $inventoryStatusMsg = $('ul.js-inv-status-list', that.$productView);
  var $addBtn = $('.js-add-to-cart', that.$productView);
  $('li', $inventoryStatusMsg).hide();
  if (!!that.productData.activeSku && !!that.productData.activeSku.INVENTORY_STATUS) {
    $('.js-inv-status-' + that.productData.activeSku.INVENTORY_STATUS, $inventoryStatusMsg).show();
  }
  if ($('ul.js-inv-status-list').length != 0) {
    if (!!that.productData.activeSku && (site.productData.isComingSoon(that.productData.activeSku) || site.productData.isSoldOut(that.productData.activeSku))) {
      $btnProductPanel.hide();
      $addBtn.hide();
    }
  }

  $btnProductPanel.click(function(e) {
    e.preventDefault();
    $(document).trigger("MPP:productQV", that.tagIds);

    that.productData.productView = that.$productView;
    that.productData.activeSku = _.find(that.productData.skus, function(sku) {
      return sku.SKU_BASE_ID == that.skuId;
    });

    site.product.view.extendedQS(that.productData, qsTemplate);
  });

  return that;
};

site.product.view.extendedQS = function(quickshopData, qsTemplate) {

  var that = {
    productData: quickshopData
  };

  that.productId = that.productData.PRODUCT_ID;
  that.skuId = that.productData.productView.attr('data-sku-id');
  that.catId = that.productData.PARENT_CAT_ID;
  that.tagIds = that.catId + '~' + that.productId;

  var qs_item = Mustache.render(qsTemplate, that.productData);

  $.colorbox({
    html: qs_item,
    className: 'colorbox__quickshop',
    fixed: 'true',
    maxWidth: '90%',
    maxHeight: '90%',
    onComplete: function() {
      var $quickshop = $(".quickshop");
      var $productImages = $('.quickshop__image-container', $quickshop);
      var $quantitySelect = $('.quickshop__quantity', $quickshop);
      var $sizeSelect = $('.quickshop__price-size-select', $quickshop);
      var $skintypeSelect = $('.quickshop__skintype-select', $quickshop);

      var $inventoryStatusMsg = $("ul.js-inv-status-list", $quickshop);

      var addBtn = site.createAddButton($(".js-add-to-cart", $quickshop));
      var favBtn = $(".js-add-to-favorites", $quickshop);

      $quickshop.addClass('extended-mpp-qs');
      site.addFavoritesButton(favBtn);

      //multiple sizes
      var multipleSizes = _.pluck(that.productData.skus, 'PRODUCT_SIZE');
      multipleSizes = _.uniq(multipleSizes);
      multipleSizes = _.compact(multipleSizes).length > 1 ? true : false;
      if (that.productData.sized && multipleSizes) {
        that.productData['multiple_sizes'] = true;
      } else if ((that.productData.sized && !multipleSizes) || that.productData.shaded) {
        that.productData['multiple_sizes'] = false;
      }
      $('option[value=' + that.productData.activeSku.SKIN_TYPE + ']', $skintypeSelect).attr("selected", "selected");

      function updateSizeSelect() {
        $('option', $sizeSelect).prop('disabled', true);
        var selectedSkus = $skintypeSelect.find('option:selected').attr('data-skus').split(',');
        $(selectedSkus).each(function(index, val) {
          var $option = $('option', $sizeSelect).filter("[data-sku-base-id=" + val + "]");
          $option.prop('disabled', false);
          if (index == 0) {
            $option.prop('selected', true);
          }
        });
        $sizeSelect.trigger('change');
      }

      //Check inventory
      function showInventoryMessage(skuid) {
        var skuData = _.find(that.productData.skus, function(sku) {
          return sku.SKU_BASE_ID == skuid;
        });
        if (!skuData || !skuData.INVENTORY_STATUS) return null;
        $("li", $inventoryStatusMsg).hide();
        $(".js-inv-status-" + skuData.INVENTORY_STATUS, $inventoryStatusMsg).show();
        $inventoryStatusMsg.show();
        if(Drupal.settings.globals_variables.enable_preorder) {
          site.quickShopExposed(skuData);
        }
      }

      if (that.productData.shaded) {
        var $shadeList = $('.shade-list', $quickshop);
        var $shadeListSwatches = $('.shade-list .swatch', $quickshop);
        var $shadeSelect = $('.quickshop__shade-select', $quickshop);
        var redirectToSPP = $('.product_spp', $quickshop);

        function customSelects(init) {
          var self = this;
          $shadeSelect.each(function(index, val) {
            if (init) {
              $(this).selectBox({
                mobile: true
              });
            } else {
              $(this).selectBox('refresh');
            }
            var $shadeSelect = $(this).selectBox('control');
            var $shadeSelectOption = $($shadeSelect).data('selectBox-options'); // extra $() for iPad

            if ($shadeSelectOption != null) {
              var $shadeMenuOptions = $shadeSelectOption.find('li a');
              // add shade divs to custom select
              $shadeMenuOptions.each(function() {
                var shadeSku = $(this).attr('rel');
                var shadeProductData = _.find(that.productData.skus, function(sku) {
                  return sku.SKU_BASE_ID == shadeSku;
                });
                var shadeHex = shadeProductData.HEX_VALUE_STRING;

                // explode
                var shadeHex = shadeHex.split(',');

                //sort swathes
                var swatchType, hexValue1, hexValue2, hexValue3, hexValue4, hexValue5;
                if (shadeHex.length == 1) {
                  swatchType = 'swatches--single';
                  hexValue1 = shadeHex[0];
                } else if (shadeHex.length == 2) {
                  swatchType = 'swatches--duo';
                  hexValue1 = shadeHex[0];
                  hexValue2 = shadeHex[1];
                } else if (shadeHex.length == 3) {
                  swatchType = 'swatches--trio';
                  hexValue1 = shadeHex[0];
                  hexValue2 = shadeHex[1];
                  hexValue3 = shadeHex[2];
                } else if (shadeHex.length == 4) {
                  swatchType = 'swatches--quad';
                  hexValue1 = shadeHex[0];
                  hexValue2 = shadeHex[1];
                  hexValue3 = shadeHex[2];
                  hexValue4 = shadeHex[3];
                } else if (shadeHex.length == 5) {
                  swatchType = 'swatches--quint';
                  hexValue1 = shadeHex[0];
                  hexValue2 = shadeHex[1];
                  hexValue3 = shadeHex[2];
                  hexValue4 = shadeHex[3];
                  hexValue5 = shadeHex[4];
                }

                var $swatchContainer = $('<div/>', {
                  'class': 'swatch__container ' + swatchType
                });
                for (var i = 0; i < shadeHex.length; i++) {
                  var $swatchDiv = $('<div/>', {
                    'class': 'swatch--' + (i + 1),
                    'style': 'background-color:' + shadeHex[i]
                  });
                  $swatchContainer.append($swatchDiv);
                }

                // add to li
                $(this).prepend($swatchContainer).clone(true);
                // add to label
                if ($(this).parent().hasClass('selectBox-selected')) {
                  var $shadeSelectLabel = $shadeSelect.parent().find('.selectBox-dropdown');
                  if ($('.swatch__container', $shadeSelectLabel).length) {
                    var $clone = $swatchContainer.clone(true);
                    $('.swatch__container', $shadeSelectLabel).replaceWith($clone);
                  } else {
                    var $clone = $swatchContainer.clone(true);
                    $shadeSelectLabel.prepend($clone);
                  }
                }

                //ie8 pie attach behavior
                if (generic.env.isIE8) {
                  if (window.PIE) {
                    $('.swatches--single div').each(function(i, el) {
                      PIE.attach(this);
                    });
                  }
                }
              });
            }
          });
        }

        //Shade click event
        $shadeListSwatches.click(function(e) {
          e.preventDefault();
          var selectedSkuBaseId = $(this).attr("data-sku-base-id");

          $shadeListSwatches.removeClass("selected");
          $shadeListSwatches.filter("[data-sku-base-id=" + selectedSkuBaseId + "]").addClass("selected");

          var skuData = _.find(that.productData.skus, function(sku) {
            return sku.SKU_BASE_ID == selectedSkuBaseId;
          });

          skuData.quantity = $quantitySelect.val();
          //that.productData.productView.trigger('sku:shop', skuData);
          $productImages.trigger('sku:select', skuData);

          $shadeSelect.val(selectedSkuBaseId);
          customSelects(false);

          //Check inventory
          showInventoryMessage(selectedSkuBaseId);

          //Change the shade SKU_BASE_ID in the url hash to reflect the newly selected shade
          redirectToSPP.attr('href', redirectToSPP.attr('data-prod-url') + '#' + selectedSkuBaseId);

          addBtn.$addButton.trigger('sku:select', skuData);
          addBtn.$addButton.trigger('inventory_status_stored', skuData);

          favBtn.trigger('sku:select', skuData);

        });

        $shadeSelect.on('change', function(e) {
          var selectedSkuBaseId = $(this).val();
          var skuData = _.find(that.productData.skus, function(sku) {
            return sku.SKU_BASE_ID == selectedSkuBaseId;
          });
          $shadeListSwatches.filter('a[data-sku-base-id=' + selectedSkuBaseId + ']').trigger('click');
          if(Drupal.settings.globals_variables.enable_preorder) {
            site.quickShopExposed(skuData);
          }
        });

        //select the corresponding swatch
        $shadeListSwatches.filter('a[data-sku-base-id=' + that.skuId + ']').trigger('click');
        customSelects(true);
      } else {
        //Check inventory
        showInventoryMessage(that.skuId);
      }

      $sizeSelect.change(function(event) {
        var selectedSku = $(this).find('option:selected').attr('data-sku-base-id');
        var skuData = _.find(that.productData.skus, function(sku) {
          return sku.SKU_BASE_ID == selectedSku;
        });

        //site.skuSelect(skuData);
        addBtn.$addButton.trigger('sku:select', skuData);
        addBtn.$addButton.trigger('inventory_status_stored', skuData);

        favBtn.trigger('sku:select', skuData);

        $('img', $productImages).attr("src", skuData.XL_IMAGE);

        //Check inventory
        showInventoryMessage(selectedSku);
        if(Drupal.settings.globals_variables.enable_preorder) {
          site.quickShopExposed(skuData);
        }
      });

      $skintypeSelect.change(function(event) {
        if ($sizeSelect.length) {
          updateSizeSelect();
          $sizeSelect.selectBox('refresh');
        } else {
          var selectedSku = $(this).find('option:selected').attr('data-skus');
          var skuData = _.find(that.productData.skus, function(sku) {
            return sku.SKU_BASE_ID == selectedSku;
          });
          addBtn.$addButton.trigger('sku:select', skuData);
          addBtn.$addButton.trigger('inventory_status_stored', skuData);

          favBtn.trigger('sku:select', skuData);
          $('img', $productImages).attr("src", skuData.XL_IMAGE);

          //Check inventory
          showInventoryMessage(selectedSku);
          if(Drupal.settings.globals_variables.enable_preorder) {
            site.quickShopExposed(skuData);
          }
        }
      });

      if ($sizeSelect.length) {
        if($skintypeSelect.length) {
          updateSizeSelect();
        }
        $sizeSelect.find('option').filter('option[data-sku-base-id=' + that.skuId + ']').attr("selected", "selected");
        $sizeSelect.trigger('change');
        $sizeSelect.selectBox();

        //Down Price Updated for Sized Products
        $sizeSelect.find('option').each(function(index, val) {
          var optionElement = $("ul.quickshop__price-size-select-selectBox-dropdown-menu").last().find("li");
          if( optionElement.hasClass('option-discount-sale')) {
            var optionTextHtml = $(val).attr("data-markdown-price");
            optionElement.eq(index).find("a").html(optionTextHtml);
            $sizeSelect.attr('data-markdown-price', 1);
          }
        })
        if($sizeSelect.attr('data-markdown-price')) {
          var optionText = $sizeSelect.find('option:selected').attr('data-markdown-price');
          $sizeSelect.siblings("a.quickshop__price-size-select").find("span.selectBox-label").html(optionText);
        }
      }

      $quantitySelect.change(function(event) {
        var quantity = $(this).val();
        addBtn.$addButton.attr("data-qty", quantity);
      });

      //Down Price Updated for Sized Products
      $sizeSelect.selectBox().on('close', function() {
        if ($sizeSelect.attr('data-markdown-price')) {
          var optionChangeText = $(this).find('option:selected').attr('data-markdown-price');
          $sizeSelect.siblings("a.quickshop__price-size-select").find("span.selectBox-label").html(optionChangeText);
        }
      });

      site.product.view.qsFixedBox('.quickshop__quantity');
      site.product.view.qsFixedBox('.quickshop__price-size-select');
      site.product.view.qsFixedBox('.quickshop__shade-select');
      site.product.view.qsFixedBox('.quickshop__skintype-select');

      //add after XL_SMOOSH is added to tout-mpp-product
      $productImage = $('img', $productImages);
      $productImageCount = $productImage.length;

      $productImage.each(function(index, val) {
        var smooshCheck = $(this).attr('src').indexOf('smoosh');
        if (smooshCheck > 1) {
          $(this).parent().addClass('smoosh');
        }
      });

      if ($productImageCount > 1) {
        var slickToggleTimer1;
        var slickToggleTimer2;

        function slickToggle() {
          slickToggleTimer1 = setTimeout(function() {
            $productImages.slick('slickNext');
            slickToggleTimer2 = setTimeout(function() {
              $productImages.slick('slickPrev');
            }, 3000);
          }, 3000);
        }
        $productImages.slick({
          dots: true,
          arrows: false,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          onInit: function(args) {
            var slideLength = args.$slides.length;
            if (slideLength >= 2) {
              slickToggle();
            }
          }
        });
        $productImages.on('sku:select', function(e, skuData) {
          window.clearTimeout(slickToggleTimer1);
          window.clearTimeout(slickToggleTimer2);
          //update main images
          var newImageArray = [];
          newImageArray = skuData.XL_IMAGE;
          var newSmoosh = skuData.XL_SMOOSH;
          //newImageArray.splice(1, 0, newSmoosh);
          //determin order, what was last selected carousel order
          var currentSlide = $productImages.slick('slickCurrentSlide');
          if ($('.quickshop__image').eq(currentSlide).hasClass('smoosh')) {
            //add to beginning
            newImageArray.unshift(newSmoosh);
          } else {
            //add to end
            newImageArray.push(newSmoosh);
          }
          //getting odd duplicate, make unique
          newImageArray = _.uniq(newImageArray);
          //current slide count
          var slideCount = $('.slick-dots li', $productImages).length;
          //create new list
          for (var i = (slideCount - 1); i >= 0; i--) {
            $productImages.slick('slickRemove', i);
          }
          $(newImageArray).each(function(index, val) {
            //add smoosh class
            var smooshClass = val.indexOf('smoosh') > 1 ? 'smoosh' : '';
            //add slide
            var newSlide = '<div class="quickshop__image ' + smooshClass + '"><img src="' + val + '" /></div>'
            $productImages.slick('slickAdd', newSlide);
          });

          //Down Price Updated for Shaded Products
          var price2 = (skuData.PRICE2 === undefined) ? '' : skuData.PRICE2;
          var formattedPrice2 = (skuData.formattedPrice2 === undefined) ? '' : skuData.formattedPrice2;
          var formattedPrice = (skuData.formattedPrice === undefined) ? '' : skuData.formattedPrice;
          var productSize = (skuData.PRODUCT_SIZE === undefined) ? '' : skuData.PRODUCT_SIZE;
          var priceNode = $('.quickshop__price-text');
          var optionTextHtml;
          if (price2) {
            productSize = (productSize !== null ? (productSize + '  ') : '');
            optionTextHtml = productSize + '<span class="product__price--non-sale">' + formattedPrice2 + '</span><span class="on-sale  product__price--sale">' + formattedPrice + '</span>';
            priceNode = $('.quickshop__price-text');
            priceNode.html(optionTextHtml);
          } else {
            if (productSize !== '' && productSize !== null) {
              optionTextHtml = productSize + '&nbsp;&nbsp;' + skuData.formattedPrice;
              if (priceNode.find('.quickshop__price-loyalty').length > 0) {
                priceNode.find('quickshop__size-text').html(productSize).find('.quickshop__price-loyalty').html(skuData.formattedPrice);
              } else {
                priceNode.html(optionTextHtml);
              }
            } else {
              if (priceNode.find('.quickshop__price-loyalty').length > 0) {
                priceNode.find('.quickshop__price-loyalty').html(skuData.formattedPrice);
              } else {
                priceNode.html(skuData.formattedPrice);
              }
            }
          }
        });
        $productImages.trigger('sku:select', that.productData.activeSku);

      }

      //tabs
      var $qsTabControl = $('.quickshop__tab-control');
      var $qsTabs = $('.quickshop__tab');

      $qsTabs.hide();
      $qsTabs.eq(0).show();
      if ($qsTabControl.length == 1) {
        //hide menu
        $('.quickshop__tabs-control').hide();
      }
      $qsTabControl.addClass('quickshop__tab-control--' + $qsTabControl.length);

      $qsTabControl.click(function(event) {
        $qsTabControl.removeClass('text--bold');
        $(this).addClass('text--bold');
        var tab = $(this).attr('data-tab');
        $qsTabs.hide();
        $qsTabs.filter("[data-tab=" + tab + "]").show();
        site.ellipsis();
      });

      $('.quickshop__add-button', $quickshop).click(function(event) {
        $.colorbox.close();
      });

      $('.quickshop__review-write').click(function(event) {
        event.preventDefault();
        if (typeof $BV !== 'undefined') {
          $BV.ui("rr", "submit_review", {
            productId: that.productData.PROD_BASE_ID
          });
        }
      });
      $(window).resize(function() {
        $.colorbox.resize({
          width: '90%'
        });
      });

      $(document).trigger("MPP:productQV", [that.tagIds]);

      var $qs_container = $('.quickshop[data-product-id="' + that.productId + '"]');
      if ($qs_container.length) {
        $(document).trigger('MPP:productQV:rendered', [$qs_container]);
        // Trigger the loyalty price formatting
        var $priceLoyaltyNode = $qs_container;
        if (that.productData['multiple_sizes']) {
          $priceLoyaltyNode = $qs_container.find('.js-size-price-loyalty');
        }
        $(document).trigger('productQV:rendered:LoyaltyPrices:popupQS', [$priceLoyaltyNode]);
      }
      site.ellipsis();
    },
    onClosed: function() {
      $('.quickshop__quantity-selectBox-dropdown-menu').remove();
      $('.quickshop__price-size-select-selectBox-dropdown-menu').remove();
      $('.quickshop__shade-select-selectBox-dropdown-menu').remove();
      $('.quickshop__skintype-select-selectBox-dropdown-menu').remove();
    }
  });
  $('.quickshop .js-shade-picker .swatch').on('click', function() {
    var sku = $(document).data('SKU'+$(this).data('sku-base-id'));
    if(Drupal.settings.globals_variables.enable_preorder) {
      site.quickShopExposed(sku);
    }
  });
  return that;
};
